/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { InputSelect, Input, Label, Button, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";
/* 🧠 REDUX */

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ViewPartsCommandsVariablesAlarms = () => {
    const { t } = useTranslation();
    const Navigate = useNavigate();
    document.title = "Edição de Part Command";
    const [loading, setLoading] = useState(true);
    const [variables, setVariables] = useState([]);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());


    const targetField = useRef();
    const variableFiled = useRef();
    const typeField = useRef();

    const targetValue = useRef();
    const variableValue = useRef();
    const typeValue = useRef();

    
    const [partCommand, setPartCommand] = useState();

    useEffect(() => {
        async function getPartCommand(){
            setLoading(true)
            let currentItem = await Services.current.getPartCommandVariableAlarm(id);
            if(currentItem){
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        async function getVariables(){
            let currentItem = await Services.current.getPartCommandsVariables();
            setVariables(currentItem);
        }

        getPartCommand();
        getVariables();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(targetValue.current) && isValidField(variableValue.current) && isValidField(typeValue.current)){
        
            let form = new FormData();
            if(targetValue.current){form.append('target', targetValue.current)}
            if(variableValue.current){form.append('command_variable', variableValue.current)}
            if(typeValue.current){form.append('type', typeValue.current)}

            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editPartCommandVariableAlarm(id, form)
            if(currentitem){
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>Conexão de variável - alarme</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={"Variável Alvo"} aling="flex-start"/>
                            <InputSelect
                                key={'target'}
                                name={'target'}
                                id={'target'}
                                placeholder={"Variável Alvo"}
                                invalidMessage = {"Variável Alvo inválida!"}
                                options={variables}
                                innerRef={targetField}
                                value={partCommand?.target}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => targetValue.current = value}>
                            </InputSelect>      

                            <Label text={t("inputs.type.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='type' 
                                name='type' 
                                type="text" 
                                placeholder= {t("inputs.type.placeholder")}
                                innerRef={typeField}
                                value={partCommand?.type}
                                invalidMessage = {t("inputs.type.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => typeValue.current = text}> 
                            </Input>
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={"Variável"} aling="flex-start"/>
                            <InputSelect
                                key={'variable'}
                                name={'variable'}
                                id={'variable'}
                                placeholder={"Variável"}
                                invalidMessage = {"Variável inválida!"}
                                options={variables}
                                innerRef={variableFiled}
                                value={partCommand?.command_variable}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => variableValue.current = value}>
                            </InputSelect>
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deletePartCommandVariableAlarm(id);
                            Navigate("/PartCommandsVariablesAlarms")
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewPartsCommandsVariablesAlarms;